<template>
    <div class="col-md-6 col-lg-4">
        <div class="card">
            <div class="card-body">
                <div class="text-center">
                    <img :src="icon" :alt="title" height="50px" class="mb-4">
                    <h3 class="header-text-regular primary-color">{{ title }}</h3>
                    <p>{{ content }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Principle',
    props: ['icon', 'title', 'content']
};
</script>



// WEBPACK FOOTER //
// src/components/frontend/about/Principle.vue